import type {
  CSVFlowLoad,
  RunSmartConnectorFlowLoad,
  SmartConnector,
} from 'pages/SmartConnectors/types';
import type { FlowNode } from './types';
import steps from './steps';

export const loadToUploadStep = (
  smartConnector: SmartConnector,
  load: CSVFlowLoad,
  index: number
): FlowNode => {
  const isPrimary = load.custom_object === smartConnector.custom_object;
  return {
    id: `${load.id || 'new'}.upload.${isPrimary ? 'primary_object' : 'related_object'}.${load.custom_object}`,
    type: isPrimary
      ? steps.upload_primary_object.type
      : steps.upload_related_object.type,
    details: load,
    order: index,
  };
};

export const loadToRunSmartConnectorStep = (
  load: RunSmartConnectorFlowLoad,
  index: number
): FlowNode => {
  return {
    id: `${load.id || 'new'}.upload.run_smart_connector.${load.smart_connector_to_run}`,
    type: steps.run_smartconnector.type,
    details: load,
    order: index,
  };
};
